import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuGroup, MenuItem } from 'src/app/model/asd/asd-properties/asd-ie-type/asd-menuItem';
import { IELabel, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';


@Component({
  selector: 'app-cosy-menu',
  templateUrl: './cosy-menu.component.html',
  styleUrls: ['./cosy-menu.component.css']
})
export class CosyMenuComponent implements OnInit {
  @Input() ie:InterfaceElement;
  @Output() switchToApp: EventEmitter<any> = new EventEmitter<any>();
  public menuItems : MenuItem[] = [];
  public IE_TYPES = InterfaceElementTypes;
  public centralMenuItemList: InterfaceElement[] = [];
  public sessionID;
  public centralMenuClass : string = "";

  constructor(private uxControllerService: UXControllerService,
              private cosyCommunicationControllerService: CosyCommunicationControllerService,
              private router: Router) { }

  ngOnInit() {
    let menuItemGroups: any[]=[];
    let menuItemIndexes : any[]=[];
    let existedMenuIndex:number = -1;
    this.sessionID = this.cosyCommunicationControllerService.localSessionID;

   
    if(this.uxControllerService.appName == 'COSYframework' || 
      this.uxControllerService.appName == 'CosyFrameworkFactory'){
        this.centralMenuClass = "btn btn-sm btn-secondary centralMenuFontStyle";
      } else {
        this.centralMenuClass = "btn btn-sm  centralMenuFontStyle nav-background";
      }


    if(this.ie.TypeDID == InterfaceElementTypes.CentralMenuList){
      for(let iee of this.ie.InterfaceElements){
        if(iee.Attributes.Visible){ 
          this.centralMenuItemList.push(iee)
        }
      }
    }

    if(this.ie.TypeDID == InterfaceElementTypes.MenuList){
      for(let item of this.ie.MenuItems){
        item.MenuGroup = null;
        if(item.DisplayName == this.ie.ObjectName){
          item.Selected = true;
        } else {
          item.Selected = false;
        }
      menuItemIndexes = this.ie.MenuItems.map((e, i) => e.DisplayName === item.DisplayName ? i : '').filter(String);
      existedMenuIndex = menuItemGroups.map(function(e){return e[0]}).indexOf(menuItemIndexes[0]);
      if(menuItemIndexes.length>1 && existedMenuIndex <0){
        menuItemGroups.push(menuItemIndexes);
      }
      }
      this.assignedMenuItemGroups(menuItemGroups);
      this.findAndSetPreMenuGroup(this.ie.ObjectName);
      for(let mi of this.ie.MenuItems){
        if(mi.MenuGroup==null){
          this.menuItems.push(mi);
        }
        else if(mi.MenuGroup!= null && mi.MenuGroup.Head == true && mi.MenuGroup.Member == false){
          this.menuItems.push(mi);
        }
      }
    }
  }

  switchToAppCall(){
    this.switchToApp.emit();
  }

  assignedMenuItemGroups(menuItemGroups:any[]){
    let menuMembersLength: number = 0;
    let assignedCSS : any;
    if(menuItemGroups.length>0){
      for(let mg of menuItemGroups){
        menuMembersLength = mg[1] - mg[0];
        if(this.ie.MenuItems[mg[0]].MenuGroup == null){
          this.ie.MenuItems[mg[0]].MenuGroup = new MenuGroup();
          this.ie.MenuItems[mg[0]].MenuGroup.Head = true;
          this.ie.MenuItems[mg[0]].MenuGroup.Member = false;
          this.ie.MenuItems[mg[0]].MenuGroup.DetailView = false;
          for(let m=1;m<menuMembersLength;m++){
            let mIndex = mg[0]+m;
            this.ie.MenuItems[mIndex].MenuGroup = new MenuGroup();
            this.ie.MenuItems[mIndex].MenuGroup.Member = true;
            this.ie.MenuItems[mIndex].MenuGroup.Head = false;
            this.ie.MenuItems[mIndex].MenuGroup.MemberOfHead=this.ie.MenuItems[mg[0]].DisplayName;
            this.ie.MenuItems[mIndex].MenuGroup.Parents.push(this.ie.MenuItems[mg[0]].DisplayName);
            assignedCSS = "move-left-m-nh-"+this.ie.MenuItems[mIndex].MenuGroup.Parents.length;
            this.ie.MenuItems[mIndex].MenuGroup.CSSClass = assignedCSS;
          }
          this.ie.MenuItems[mg[1]].MenuGroup = new MenuGroup();
          this.ie.MenuItems[mg[1]].MenuGroup.Closure = true;
        }
        else if(this.ie.MenuItems[mg[0]].MenuGroup!= null){
          this.ie.MenuItems[mg[0]].MenuGroup.Head = true;
          assignedCSS = "move-left-m-h-"+this.ie.MenuItems[mg[0]].MenuGroup.Parents.length;
          this.ie.MenuItems[mg[0]].MenuGroup.CSSClass = assignedCSS;
          for(let m=1;m<menuMembersLength;m++){
            let mIndex = mg[0]+m;
            this.ie.MenuItems[mIndex].MenuGroup.Member = true;
            this.ie.MenuItems[mIndex].MenuGroup.Head = false;
            this.ie.MenuItems[mIndex].MenuGroup.MemberOfHead=this.ie.MenuItems[mg[0]].DisplayName;
            this.ie.MenuItems[mIndex].MenuGroup.Parents.push(this.ie.MenuItems[mg[0]].DisplayName);
            assignedCSS = "move-left-m-nh-"+this.ie.MenuItems[mIndex].MenuGroup.Parents.length;
            this.ie.MenuItems[mIndex].MenuGroup.CSSClass = assignedCSS;
          }
          this.ie.MenuItems[mg[1]].MenuGroup.Closure = true;
        }
      }
    }
  }

  findAndSetPreMenuGroup(selectedMenuName: any){
    let indexOfSelectedMenu : number = -1;
    let selectedMenuIndex = this.ie.MenuItems.map(function(e){return e.DisplayName}).indexOf(selectedMenuName);
    if(selectedMenuIndex>-1 && this.ie.MenuItems[selectedMenuIndex].MenuGroup!=null){
      if(this.ie.MenuItems[selectedMenuIndex].MenuGroup.MemberOfHead!=null){
        for(let p of this.ie.MenuItems[selectedMenuIndex].MenuGroup.Parents){
          indexOfSelectedMenu = this.ie.MenuItems.map(function(e){return e.DisplayName}).indexOf(p);
          this.onDetailViewclicked(this.ie.MenuItems[indexOfSelectedMenu])
        }
      }
    }
  }

  onDetailViewclicked(menuItem: MenuItem){
    if(menuItem!= null){
      menuItem.MenuGroup.Members = [];
      let menuItemIndexes = this.ie.MenuItems.map((e, i) => e.DisplayName === menuItem.DisplayName ? i : '').filter(String);
      let startIndex: number, endIndex: number;
      startIndex = parseInt(menuItemIndexes[0].toString())+1;  
      endIndex =  parseInt(menuItemIndexes[1].toString())-1
      for(let m=startIndex ; m<=endIndex; m++){
        if(this.ie.MenuItems[m].MenuGroup.Closure == null && this.ie.MenuItems[m].MenuGroup.MemberOfHead == menuItem.DisplayName ){
          menuItem.MenuGroup.Members.push(this.ie.MenuItems[m]);
        }
      }
      if(menuItem.MenuGroup.DetailView == false){ menuItem.MenuGroup.DetailView = true}
      else  if(menuItem.MenuGroup.DetailView == true) menuItem.MenuGroup.DetailView = false;
    }
    
  }

  fetchIEUserAction(userActionID: string, value: any, attributeKey: string, additionalAttributes: any[], additionalInterfaceElements: InterfaceElement[]) {
    
    if (userActionID != null) {
      this.uxControllerService.isMenuClick = true;
      this.uxControllerService.fetchUserAction(userActionID, this.ie, null, value, attributeKey, additionalAttributes, additionalInterfaceElements, null, null);
    }
  }

  onNotifySelectNode($event) {
    let recievedNote = $event;
    if (recievedNote.uaid != null) {

      this.uxControllerService.fetchIEUserAction(recievedNote.uaid,recievedNote.ie,null,null,null,null,null,null);
    }
  }

  logoutFromApp(){
    this.cosyCommunicationControllerService.closeSessionKey(this.uxControllerService.sessionID).subscribe(
      error => console.error('ERROR: ', error),
      () => { 
            this.uxControllerService.currentBreadCrumbTitle = 'LogOut';
            this.router.navigate(['/server']);
      }
    );
  }
}
